// extracted by mini-css-extract-plugin
export default {"tooltipIcon":"styles_tooltipIcon__kvADE","tooltipRowText":"styles_tooltipRowText__9kX7M","tooltipRow":"styles_tooltipRow__l8z99"};